import { validatePresence } from 'ember-changeset-validations/validators';

export const TaskValidation = {
  title: validatePresence(true),
  dueAt: validatePresence(true),
};
